import {
  ColumnLayout,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import InfoField from "../UI/InfoField";
import { CODE_MASTER, getDivisionLabel } from "../default-constants";
import { BankAccountForBankAccount } from "../../features/api-interfaces";

interface IBankAccountReference {
  bankAccount?: BankAccountForBankAccount;
  isModalOpen: boolean;
}

/**
 * 入金口座情報照会 口座情報
 */
export const BankAccountReference = (props: IBankAccountReference) => {
  const { bankAccount, isModalOpen } = props;

  return (
    <>
      {isModalOpen ? (
        <SpaceBetween direction={"horizontal"} size={"l"}>
          <ColumnLayout columns={4}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[
                LABELS.BANK_CODE,
                LABELS.BANK_NAME,
                LABELS.BRANCH_CODE,
                LABELS.BRANCH_NAME,
                LABELS.BANK_ACCOUNT_TYPE,
                LABELS.BANK_ACCOUNT_NUMBER,
                LABELS.BANK_ACCOUNT_HOLDER_KANA,
              ]}
            />
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <InfoField
              direction={"vertical"}
              size={"xxxs"}
              tag={"p"}
              values={[
                bankAccount?.fnnInsMthStrCd,
                bankAccount?.fnnInsMthStrNm,
                bankAccount?.fnnInsBrnCd,
                bankAccount?.fnnInsBrnNm,
                getDivisionLabel(
                  CODE_MASTER["BANK_ACCOUNT_TYPE"],
                  String(bankAccount?.bankAccountType ?? "")
                ),
                bankAccount?.bankAccountNumber,
                bankAccount?.bankAccountHolderKana,
              ]}
            />
          </ColumnLayout>
        </SpaceBetween>
      ) : (
        <SpaceBetween direction={"horizontal"} size={"xxl"}>
          <ColumnLayout columns={2}>
            <InfoField
              direction={"vertical"}
              size={"xxs"}
              tag={"h4"}
              values={[
                LABELS.BANK_CODE,
                LABELS.BANK_NAME,
                LABELS.BRANCH_CODE,
                LABELS.BRANCH_NAME,
                LABELS.BANK_ACCOUNT_TYPE,
                LABELS.BANK_ACCOUNT_NUMBER,
                LABELS.BANK_ACCOUNT_HOLDER_KANA,
              ]}
            />
          </ColumnLayout>
          <InfoField
            direction={"vertical"}
            size={"xxxs"}
            tag={"p"}
            values={[
              bankAccount?.fnnInsMthStrCd,
              bankAccount?.fnnInsMthStrNm,
              bankAccount?.fnnInsBrnCd,
              bankAccount?.fnnInsBrnNm,
              getDivisionLabel(
                CODE_MASTER["BANK_ACCOUNT_TYPE"],
                String(bankAccount?.bankAccountType ?? "")
              ),
              bankAccount?.bankAccountNumber,
              bankAccount?.bankAccountHolderKana,
            ]}
          />
        </SpaceBetween>
      )}
    </>
  );
};
